import { Input, InputAdornment } from '@tencent/tea-component';
import _ from 'lodash';
import { useEffect } from 'react';

const { TextArea } = Input;

export default function InputField(props) {
  const { prefix, suffix, type, onChange, defaultValue, ...restProps } = props;

  const finalOnChange = (value) => {
    let finalValue = value;
    switch (type) {
      case 'number':
        finalValue = value.replace(/[^\d]/g, '');
        break;
    }
    onChange(finalValue);
  };

  useEffect(() => {
    if (props.form) {
      props.form.handler.change(props.name, defaultValue);
    }
  }, [defaultValue]);

  if (restProps.readOnly) {
    return _.get(restProps, 'value', '');
  }

  return (
    <InputAdornment before={prefix} after={suffix}>
      <Input {...restProps} onChange={finalOnChange} />
    </InputAdornment>
  );
}

InputField.TextArea = (props) => {
  if (props.readOnly) {
    return props.value || '';
  }
  return <TextArea {...props} />;
};
